import { CoreButton, CoreModal } from '@komodo-design-system/komodo-components-react';
import React, { useEffect } from 'react';
import { domParser } from 'utils/utils';

interface SKUTableProps {
  alert: Record<string, any>;
  handleClose: () => void;
}

const SKUTable: React.FC<SKUTableProps> = ({ alert, handleClose }) => {
  const [expandedRows, setExpandedRows] = React.useState<{ [key: string]: boolean }>({});
  console.log('SKUTable alert', expandedRows);

  useEffect(() => {
    // Reset expanded rows when alert is closed
    return () => {
      setExpandedRows({});
    };
    // }
  },[]);

  const skuTableClose = ()=>{
    setExpandedRows({});
    handleClose();
  };

  // Group data by webId
  const groupByWebId = () => {
    return alert?.row?.reduce((acc: Record<string, any[]>, item: any) => {
      const webId = item.webId;
      if (!acc[webId]) {
        acc[webId] = [];
      }
      acc[webId].push(item);
      return acc;
    }, {});
  };

  // Toggle row expansion
  const toggleRow = (webId: string) => {
    setExpandedRows((prevState) => ({
      ...prevState,
      [webId]: !prevState[webId],
    }));
  };

  const renderRows = (groupedData: Record<string, any[]>) => {
    return Object.keys(groupedData).map((webId, index) => {
      const items = [...groupedData[webId]]; // Create a copy of the array
      const isExpandable = items.length > 1;
      const isExpanded = expandedRows[webId];
      const allSameErp = [...groupedData[webId]].length>1 && [...groupedData[webId]].every(item => item.erp === items[0].erp);
      const allSameTargetSite = [...groupedData[webId]].length>1 && [...groupedData[webId]].every(item => item.targetSite === items[0].targetSite);
        
      const newArray = items.filter((item, i) => i !== 0); // Create a new array excluding the first item

      return (
        <React.Fragment key={index}>
          {/* Parent Row */}
          
          <tr className={isExpanded ? "parent-row" :""}>
            <td>
              {isExpandable && (
                <span title='Click here to view all SKUs'
                  data-testid={`toggle-icon-${webId}`}
                  className={`icon-16-${isExpanded ? 'minus' : 'plus'}-mono color-blue`}
                  onClick={() => toggleRow(webId)}
                  style={{ cursor: 'pointer' }}
                ></span>
              )}
            </td>
            <td>{webId}</td>
            <td>{items[0]?.mpn || ''}</td>
            <td>{items[0]?.rootSku || ''}</td>
            <td>{items[0]?.gid || ''}</td>
            <td>{items[0]?.erp + (((isExpandable && !allSameErp) && !isExpanded) ? ' ...' : '')}</td> {/* Show ellipsis if ERP values differ */}
            <td>{(items[0]?.targetSite || '' )+ (((isExpandable && !allSameTargetSite) && !isExpanded) ? ' ...':'')}</td>
            <td>{domParser(items[0]?.productTitle) || ''}</td>
          </tr>
          {/* Child Rows */}
        
          {isExpandable &&
            isExpanded &&
            newArray.map((item: any, childIndex: number) => (
              <tr key={childIndex} className={`child-row${childIndex === newArray.length - 1 ? ' last-child' : ''}`}>
                <td></td>
                <td>{item.webId}</td>
                <td>{item.mpn}</td>
                <td>{item.rootSku}</td>
                <td>{item.gid}</td>
                <td>{item.erp}</td>
                <td>{item.targetSite}</td>
                <td>{domParser(item.productTitle)}</td>
              </tr>
            ))}
        </React.Fragment>
      );
    });
  };

  // Generate table
  const generateTable = () => {
    const groupedData = groupByWebId();
    return (
      <div className="table-wrapper">
        <table className="collision-window">
          <thead>
            <tr>
              <th style={{ padding:0 }}></th>
              <th style={{ width: '10%' }}>Web Id</th>
              <th style={{ width: '15%' }}>MPN</th>
              <th style={{ width: '10%' }}>Root SKU</th>
              <th style={{ width: '10%' }}>GID</th>
              <th style={{ width: '10%' }}>ERP</th>
              <th style={{ width: '10%' }}>Target Site</th>
              <th style={{ width: '40%' }}>Product Title</th>
            </tr>
          </thead>
          <tbody style={{ fontSize: '12px' }}>{renderRows(groupedData)}</tbody>
        </table>
      </div>
    );
  };

  return (
    <div data-testid="alert-box" className="alert-boxv2">
      <CoreModal
        className="alert-box-modal"
        data-testid="alert-box-modal"
        isopen ={alert?.open}
        bgclose
        header='SKU Details'
        closeicon={true}
        onModalClosedTrigger={skuTableClose}
      >
        <span className='sku-sub-title'>This details is grouped based on web id</span>
        {generateTable()}

        <CoreButton style={{float:'right'}} label='OK' onClick={skuTableClose}>Ok</CoreButton>
      </CoreModal>
    </div>
  );
};

export default SKUTable;